import styled from 'styled-components';

const RemessaDetailsTitle = styled.h3`
  font-weight: 600;
  margin-bottom: 20px;
`;

export default RemessaDetailsTitle;
